/**
 * 矢量工具
 * @see https://github.com/fex-team/kity/blob/dev/src/graphic/vector.js
 */
export class Vector {
    /**
     * 创建从 v1 指向 v2 的矢量
     * @param {Vector} v1
     * @param {Vector} v2
     */
    static from(v1, v2) {
        return new Vector(v2.x - v1.x, v2.y - v1.y);
    }

    /**
     * 创建矢量
     * @param {number} x
     * @param {number} y
     */
    constructor(x = 0, y = 0) {
        this.x = x;
        this.y = y;
    }

	*[Symbol.iterator]() {
		yield this.x;
		yield this.y;
	}

    /**
     * 平方
     */
    square() {
        return this.x * this.x + this.y * this.y;
    }

    /**
     * 长度
     */
    length() {
        return Math.sqrt(this.square());
    }

    /**
     * 矢量相加
     * @param {Vector} q
     */
    add(q) {
        return new Vector(this.x + q.x, this.y + q.y);
    }

    /**
     * 矢量相减
     * @param {Vector} q
     */
    minus(q) {
        return new Vector(this.x - q.x, this.y - q.y);
    }

    /**
     * 点积
     * @param {Vector} q
     */
    dot(q) {
        return this.x * q.x + this.y * q.y;
    }

    /**
     * 在 q 上的投影
     * @param {Vector q}
     */
    project(q) {
        return q.multipy(this.dot(q) / q.square());
    }

    /**
     * 矢量伸缩
     * @param {Number} scale
     */
    multipy(scale) {
        return new Vector(this.x * scale, this.y * scale);
    }

    /**
     * 修改长度
     * @param {Number} length
     */
    normalize(length = 1) {
        return this.multipy(length / this.length());
    }

    /**
     * 旋转
     * @param {number} angle 角度
     * @param {"rad"|"deg"} unit 单位，默认为弧度（deg）
     */
    rotate(angle, unit = 'deg') {
        const rad = unit == 'deg' ? angle * Math.PI / 180 : angle;
        const sin = Math.sin(rad);
        const cos = Math.cos(rad);

        const a = cos, b = sin, c = -sin, d = cos, e = 0, f = 0;
        const { x, y } = this;

        return new Vector(a * x + c * y + e, b * x + d * y + f);
    }

    /**
     * 垂线
     */
    vertical() {
        return new Vector(this.y, -this.x);
    }

    /**
     * 反转
     */
    reverse() {
        return this.multipy(-1);
    }

    /**
     * 计算角度，返回值为角度（-180 ~ 180）
     */
    getAngle() {
        var length = this.length();
        if (length === 0) return 0;
        var rad = Math.acos(this.x / length);
        var sign = this.y > 0 ? 1 : -1;
        return sign * 180 * rad / Math.PI;
    }
}


// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/imagePlugin/ImageEditor/tools/Vector.js